import { render, staticRenderFns } from "./AbandonTest.vue?vue&type=template&id=9212fc38&scoped=true"
import script from "./AbandonTest.vue?vue&type=script&lang=js"
export * from "./AbandonTest.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9212fc38",
  null
  
)

export default component.exports